__turbopack_context__.v({
  "center_form": "styles-module-scss-module__3oUkzq__center_form",
  "details_text": "styles-module-scss-module__3oUkzq__details_text",
  "disclaimer": "styles-module-scss-module__3oUkzq__disclaimer",
  "header": "styles-module-scss-module__3oUkzq__header",
  "step_two": "styles-module-scss-module__3oUkzq__step_two",
});
